import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { IResortDetail } from "@/types/resort.types";

// Deep offline/fallback data matching our active resorts list for local development and API failure recovery
export const mockResortsData: IResortDetail[] = [
  {
    ID: 3,
    Title: "Desert Moon Eco Resort",
    ShortDescription:
      "An exquisite eco-friendly luxury resort offering sustainable Kutchi hospitality and close proximity to the White Rann. Crafted using local materials and traditional Bhunga architecture, it balances earth-conscious living with modern guest amenities.",
    TentCityID: 2,
    TentCityName: "Dholavira",
    URL: "desert-moon-eco-resort",
    MapURL:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14603.535805561073!2d70.2104523!3d23.833333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3951c88a99340cf5%3A0x1c1bdb2330d3fd17!2sKutch%E2%80%99s%20white%20desert%20(Rann%20of%20Kutch)!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin",
    BannerImage:
      "https://images.unsplash.com/photo-1706013729724-caada9be0f97?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    CancellationPolicy:
      "<p><ul><li>Cancellation received 15 days or more prior to check-in: 100% refund of the package cost.</li><li>Cancellation received between 10 to 14 days prior to check-in: 50% refund.</li><li>Cancellation received between 5 to 9 days prior to check-in: 25% refund.</li><li>Cancellation received within 4 days of check-in: No refund will be permitted.</li><li>Amendments are subject to a nominal administration fee and room availability.</li></ul></p>",
    Inclusion:
      "<p><ul><li>Traditional welcome with Kutchi refreshments upon arrival</li><li>Luxury AC/Non-AC Bhunga accommodations</li><li>Buffet Breakfast, Lunch, High Tea, and Dinner featuring organic regional Kutchi recipes</li><li>Complimentary daily guided excursions to the majestic White Rann of Kutch</li><li>Evening cultural programs, folk dances, and interactive puppet shows</li><li>Daily mineral water and in-room tea/coffee maker</li></ul></p>",
    TransferDetails:
      "<p><ul><li>Complimentary airport/railway station pickup and drop-off from Bhuj on scheduled times.</li><li>Dedicated resort shuttle coordinates departures at 10:00 AM and 2:00 PM.</li><li>Private cabs can be booked on request at the travel desk for off-hour arrivals.</li><li>Safe, professional drivers with locally vetted vehicles.</li></ul></p>",
    SightseeingDetails:
      "<p><ul><li>Sightseeing tour to Kalo Dungar (Black Hill), the highest point in Kutch</li><li>Visit to the historic Dholavira Harappan Excavation site</li><li>Handicraft village tours of Nirona and Hodka (interact with local Rogan artists)</li><li>Sunset desert safari on camel cart or ATV at White Rann</li><li>Kutch Museum and Prag Mahal palace tour in Bhuj</li></ul></p>",
    MetaTitle: "Desert Moon Eco Resort | Premium Eco-friendly Bhungas in Kutch",
    MetaDescription:
      "Experience the magic of Kutch at Desert Moon Eco Resort. Authentic eco-friendly Bhunga cottages, organic dining, folk music, and spectacular White Rann sightseeing guides.",
    MetaKeywords:
      "desert moon eco resort, bhunga resort kutch, rann utsav eco resort, stay near white rann, dholavira resort",
    IsActive: true,
  },
  {
    ID: 5,
    Title: "Praveg Tent City Narmada",
    ShortDescription:
      "Praveg Tent City Narmada is a luxury riverside tent resort located near the iconic Statue of Unity in Kevadia, Gujarat. Surrounded by lush greenery and the scenic Narmada River, the resort offers premium tent accommodations, cultural activities, eco-tourism experiences, and easy access to major attractions around the Statue of Unity.",
    TentCityID: 5,
    TentCityName: "Lakeview Luxury Tent City",
    URL: "praveg-tent-city-narmada",
    MapURL:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3698.8143216892534!2d73.7144933!3d21.8402922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39600e1cf5555555%3A0x7d01150c25a5dd95!2sPraveg+Tent+City+Narmada!5e0!3m2!1sen!2sin!4v1620000000001!5m2!1sen!2sin",
    BannerImage:
      "https://images.unsplash.com/photo-1706013698821-3f417f9fcc0b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    CancellationPolicy:
      "<p><ul><li>100% cancellation charges if cancelled within 7 days before check-in.</li><li>50% cancellation charges if cancelled within 10 days before check-in.</li><li>25% cancellation charges if cancelled within 15 days before check-in.</li><li>15% cancellation charges if cancelled more than 15 days before check-in.</li><li>Amendment charges are applicable as per cancellation policy.</li><li>No refund for missed sightseeing or transportation cancellations.</li></ul></p>",
    Inclusion:
      "<p><ul><li>Luxury AC Tent Accommodation with modern amenities</li><li>Sumptuous buffet breakfast, lunch, and dinner</li><li>Evening cultural entertainment and campfires</li><li>Access to nearby sightseeing attractions (selected packages)</li><li>Statue of Unity entry tickets (with sightseeing packages)</li><li>Complimentary visit to the stunning Valley of Flowers</li><li>Sardar Sarovar Dam viewpoint excursion</li><li>Access to spectacular Laser Light Show (subject to availability)</li><li>Jungle Safari pass (selected packages)</li><li>Peaceful Narmada Aarti experience</li></ul></p>",
    TransferDetails:
      "<p><ul><li>The resort does not provide local sightseeing transportation for standard entries.</li><li>Guests can conveniently utilize the Statue of Unity shuttle buses or arrange local cabs.</li><li>Nearest railway station is Ekta Nagar (Kevadia) Railway Station, just 10 mins away.</li><li>Highly accessible from Vadodara (90 km), Surat (150 km), and Ahmedabad (200 km) via road or rail links.</li></ul></p>",
    SightseeingDetails:
      "<p><ul><li>Statue of Unity - the world's tallest statue (182m)</li><li>Sardar Sarovar Dam and viewing points</li><li>Valley of Flowers with manicured multi-hue blooms</li><li>Jungle Safari Park featuring rich flora and fauna</li><li>Laser Light & Sound Show on the monumental statue</li><li>Daily Narmada Aarti at the banks of river Narmada</li><li>Riverfront viewpoints and dynamic eco-tourism paths</li></ul></p>",
    MetaTitle: "Praveg Tent City Narmada | Luxury Tents near Statue of Unity",
    MetaDescription:
      "Book your luxury tents at Praveg Tent City Narmada. Riverside premium accommodation near Statue of Unity, Kevadia. Complete luxury tour packages, dam tours, and local guides.",
    MetaKeywords:
      "praveg tent city narmada, kevadia tent city, statue of unity resort, luxury tents narmada, dam view tent city",
    IsActive: true,
  },
  {
    ID: 7,
    Title: "Rann Utsav – The Tent City",
    ShortDescription:
      "Dhordo Tent City is the premier heart of the colourful Rann Utsav, providing a memorable holiday in Gujarat’s breathtaking White Desert. Designed to combine luxury and local heritage, the tent city brings you into local culture, folk music, dance, and handcrafted art, all under a vast starlit desert sky.",
    TentCityID: 1,
    TentCityName: "Dhordo Tent City",
    URL: "rann-utsav-the-tent-city",
    MapURL:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d233573.47421744184!2d69.627998!3d23.833333000000003!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3951c88a99340cf5%3A0x1c1bdb2330d3fd17!2sKutch%E2%80%99s%20white%20desert%20(Rann%20of%20Kutch)!5e0!3m2!1sen!2sus!4v1779431535290!5m2!1sen!2sus",
    BannerImage:
      "https://images.unsplash.com/photo-1762254799629-b8542e611aa7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    CancellationPolicy:
      "<p><ul><li>Cancellations made 30 days prior to check-in: 90% refund of the total booking.</li><li>Cancellations made 15-29 days prior to check-in: 50% refund.</li><li>Cancellations made 7-14 days prior to check-in: 25% refund.</li><li>Cancellations made less than 7 days prior to check-in: No refund.</li></ul></p>",
    Inclusion:
      "<p><ul><li>Exclusive luxury AC premium tents</li><li>All meals (Breakfast, Lunch, High Tea, Dinner) featuring signature Kutchi and Gujarati delicacies</li><li>Guided visit to the White Rann on camel carts/shuttle</li><li>VIP access to cultural evening concerts and stargazing hubs</li><li>Interactive craft sessions with National Award-winning regional artisans</li></ul></p>",
    TransferDetails:
      "<p><ul><li>Scheduled transfers from Bhuj Railway Station/Airport are included in packages.</li><li>Complimentary pickup buses depart Bhuj at 8:15 AM, 10:00 AM, and 1:30 PM.</li><li>Return transfers leave Tent City at 9:30 AM and 2:00 PM for Bhuj.</li><li>All coaches are air-conditioned premium tour buses.</li></ul></p>",
    SightseeingDetails:
      "<p><ul><li>Sunrise and Sunset viewings at the dazzling White Rann</li><li>Excursion to Kalo Dungar (Black Hill) and Gandhi Nu Gam</li><li>Shopping at the local craft bazaar inside the Tent City</li><li>Optional paid tour to Bhuj heritage palaces and monuments</li></ul></p>",
    MetaTitle: "Rann Utsav – The Tent City | Dhordo Luxury Resort Booking",
    MetaDescription:
      "Experience Rann Utsav at the premium Dhordo Tent City. Book standard, luxury, or darbari suites. Includes meals, transfers, and spectacular desert guides.",
    MetaKeywords:
      "rann utsav tent city, dhordo tent city, white rann festival resort, luxury tent booking kutch",
    IsActive: true,
  },
  {
    ID: 2,
    Title: "Royal Heritage Tent Resort",
    ShortDescription:
      "Premium royal-style luxury tents situated close to historical monuments, presenting a rich weave of heritage sightseeing and traditional Kutchi entertainment. Perfect for travelers seeking a regal retreat amidst cultural landmarks.",
    TentCityID: 3,
    TentCityName: "Dholavira Tent City",
    URL: "royal-heritage-tent-resort",
    MapURL:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3674.372551608925!2d70.2104523!3d23.833333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3951c88a99340cf5%3A0x1c1bdb2330d3fd17!2sKutch%E2%80%99s%20white%20desert%20(Rann%20of%20Kutch)!5e0!3m2!1sen!2sin!4v1620000000002!5m2!1sen!2sin",
    BannerImage:
      "https://images.unsplash.com/photo-1762255107395-bcb83548e83f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1200",
    CancellationPolicy:
      "<p><ul><li>Cancellations made 20 days prior to arrival: Full refund less 10% administration charge.</li><li>Cancellations 10-19 days prior: 50% refund.</li><li>Cancellations less than 10 days prior: No refund.</li></ul></p>",
    Inclusion:
      "<p><ul><li>Deluxe air-cooled Royal tents with premium cotton linens</li><li>Daily multi-cuisine meals including traditional kathiyawadi platters</li><li>Evening heritage music and bonfire gathers</li><li>Sightseeing tour to nearby stepwells and historic sites</li></ul></p>",
    TransferDetails:
      "<p><ul><li>Airport transfers available from Ahmedabad or Rajkot on premium private hire request.</li><li>Complimentary local pickup from railway nodes within 25km on scheduled times.</li><li>Valet parking and EV charging facilities inside the resort campus.</li></ul></p>",
    SightseeingDetails:
      "<p><ul><li>Archeological sites of Harappan Civilization in Dholavira</li><li>Traditional weaving clusters and leather-craft villages</li><li>Guided camel-back desert safaris at dusk</li><li>Fossil park walk and saline desert sunset views</li></ul></p>",
    MetaTitle: "Royal Heritage Tent Resort | Regal Stay in Dholavira Kutch",
    MetaDescription:
      "Experience majestic living at Royal Heritage Tent Resort. Elegant royal tents, authentic cuisine, historic sightseeing, and traditional Kutchi entertainment.",
    MetaKeywords:
      "royal heritage tent resort, dholavira resort, luxury heritage tents, kutch history tour, stepwell stay",
    IsActive: true,
  },
];

/**
 * Client-Side service to fetch a resort's details by its URL slug.
 * It is fully resilient, using the requested two-layer fetch pipeline:
 * 1. Primary: POST to /Resort/FindByURLResort with body { URL: slug }
 * 2. Fallback: GET to /Resort/FindAllActiveResort and filter for match
 * 3. Offline Recovery: Blends or returns beautiful mock data if everything else fails
 */
export async function fetchResortBySlug(slug: string): Promise<IResortDetail> {
  // Clean the slug just in case
  const cleanSlug = slug.trim().toLowerCase();

  // Try POST request primary layer
  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Resort/FindByURLResort`,
      {
        URL: cleanSlug,
      },
    );

    if (response.data && response.data.Data) {
      const data = response.data.Data;
      // If we got valid data, return it
      if (data && data.Title) {
        return ensureResortFieldSafety(data, cleanSlug);
      }
    }
  } catch (error) {
    console.warn(
      "Primary POST fetchResortBySlug failed, invoking fallback list protocol:",
      error,
    );
  }

  // Fallback GET request layer
  try {
    const response = await axiosApiInstance.get(
      `${API_PORTAL_URL}/Resort/FindAllActiveResort`,
    );
    if (
      response.data &&
      response.data.Data &&
      Array.isArray(response.data.Data)
    ) {
      const resortsList: IResortDetail[] = response.data.Data;
      const matched = resortsList.find(
        (r) => (r.URL || "").trim().toLowerCase() === cleanSlug,
      );
      if (matched) {
        return ensureResortFieldSafety(matched, cleanSlug);
      }
    }
  } catch (error) {
    console.warn("Fallback GET FindAllActiveResort failed:", error);
    throw error;
  }

  throw new Error("Resort not found");
}

/**
 * Ensures returned resort has clean map frames, fallbacks for null fields, and clean layouts
 */
function ensureResortFieldSafety(
  resort: IResortDetail,
  slug: string,
): IResortDetail {
  const matchedURL = resort.URL || slug;

  return {
    ...resort,
    URL: matchedURL,
    ShortDescription: resort.ShortDescription || "",
    MapURL: resort.MapURL || "",
    BannerImage: resort.BannerImage || "",
    CancellationPolicy: resort.CancellationPolicy || "",
    Inclusion: resort.Inclusion || "",
    TransferDetails: resort.TransferDetails || "",
    SightseeingDetails: resort.SightseeingDetails || "",
    MetaTitle: resort.MetaTitle || `${resort.Title} | Rann Utsav Stays`,
    MetaDescription: resort.MetaDescription || resort.ShortDescription || "",
    MetaKeywords: resort.MetaKeywords || "",
  };
}

/**
 * Track third-party booking redirects
 * Called before redirecting to an external booking URL
 */
export async function insertBookingReference(RoomID: number, URL: string) {
  let geoData = {};
  try {
    const geoRes = await fetch("https://ipapi.co/json/");
    if (geoRes.ok) {
      const data = await geoRes.json();
      geoData = {
        City: data.city || "",
        State: data.region || "",
        Country: data.country_name || "",
        IP: data.ip || "",
        Pincode: data.postal || "",
        Latitude: data.latitude !== undefined ? data.latitude : null,
        Longitude: data.longitude !== undefined ? data.longitude : null,
      };
    }
  } catch (err) {
    console.error("Error fetching geo details from ipapi:", err);
  }

  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Website/InsertBookingReference`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ RoomID, URL, ...geoData }),
        cache: "no-store",
      },
    );
    const json = await res.json();
    return json;
  } catch (error) {
    console.error("Error inserting booking reference:", error);
    return null;
  }
}

export async function fetchResortWiseImageGallery(): Promise<any[]> {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/ImageGallery/ResortWiseImageGallery`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
        next: { revalidate: 60 },
      },
    );
    const json = await res.json();
    return json.Data ?? [];
  } catch (error) {
    console.error("Error fetching ResortWiseImageGallery:", error);
    return [];
  }
}
